import script from "./related.vue?vue&type=script&setup=true&lang=js"
export * from "./related.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__